module.exports = __webpack_public_path__ + "img/google_drive_help_connexion.ebfec4fe.png";